import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { setCurrentRoute } from '../../redux/reducers/utils/navReducer';
import { sendRequestCitiesGet, sendRequestOrganizationsGet } from '../../redux/reducers/utils/servicesReducers/settingsCatalogsReducer';
import { sendRequestKitchens, sendRequestCategoriesCatalogGet } from '../../redux/reducers/utils/kitchenReducers/kitchenReducer';
import { Container, ScrolledCol } from '../../core/styles';

const FinanceModule = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { isAuth } = useSelector((store) => store.auth);
  const dispatch = useDispatch();

  useEffect(() => {
    if (location.pathname === '/finance') {
      dispatch(setCurrentRoute('finance/wallets'));
      navigate('/finance/wallets');
    }
  }, [location.pathname]);

  useEffect(() => {
    if (isAuth) {
      dispatch(sendRequestKitchens({ requestTimestamp: Date.now(), offset: 0, limit: 10000 }));
      dispatch(sendRequestCitiesGet({ requestTimestamp: Date.now() }));
      dispatch(sendRequestOrganizationsGet({ requestTimestamp: Date.now() }));
      dispatch(sendRequestCategoriesCatalogGet({ requestTimestamp: Date.now() }));
    }
  }, [isAuth]);

  return(
      <ScrolledCol>
        <Container>
          {children}
        </Container>
      </ScrolledCol>
  );
}

export default FinanceModule;